import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import PromotionWingmanBrand from '../../../assets/img/brand/pw-logo-horizontal-color-light.svg';

const img = require('../../../assets/img/brand/WaveTexture.svg');

export default class RootNavbarMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    };
  }

  onClickItem = () => {
    this.setState(
      {
        collapse: !this.state.collapse,
      },
      this.props.handleTogglerClick,
    );
  };

  render() {
    return (
      <div className="body-style">
        <Row className="header-style mr-0 ml-0">
          <Col xs={9} className="pl-0 pr-0">
            <img
              alt="Promotion Wingman brand"
              className="promotionwingman-img-login"
              src={PromotionWingmanBrand}
              height="45"
              width="157"
            />
          </Col>
          <Col xs={3} className="pr-0 pl-0 d-flex justify-content-end">
            <div
              className="close-button-style ml-0"
              onClick={this.props.handleTogglerClick}
            >
              <svg
                style={{ fill: 'url(#Gradient1)' }}
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 24 24"
              >
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                <path d="M0 0h24v24H0z" fill="none" />
                <defs>
                  <linearGradient
                    id="Gradient1"
                    x1="100%"
                    y1="0%"
                    x2="0%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#13D5E7" />
                    <stop offset="100%" stopColor="#1A4BEF" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </Col>
        </Row>
        <div className="gradient-divider d-md-none d-sm-block" />

        <div className="body-style-transition">
          <Row className="login-row-style">
            <Link to="/login">
              <div
                className="person-icon-style-mobile"
                onClick={this.onClickItem}
              >
                <svg
                  className="person-icon-style-mobile-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="6vh"
                  height="5.0vh"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </div>
            </Link>
            <Col xs={12} className="login-item-text">
              {' '}
              LOGIN
            </Col>
          </Row>

          <Row className="middle-row-style">
            <Col
              xs={12}
              className="middle-menu-item"
              onClick={this.onClickItem}
            >
              <Link to="/">Home</Link>
            </Col>
            <Col
              xs={12}
              className="middle-menu-item"
              onClick={this.onClickItem}
            >
              <Link to="/support">Support</Link>
            </Col>
            <Col
              xs={12}
              className="middle-menu-item"
              onClick={this.onClickItem}
            >
              <Link to="/auth/signup">Sign Up</Link>
            </Col>
          </Row>

          <Row
            className="last-row-style"
            style={{ backgroundImage: `url(${img})` }}
          >
            <Row className="last-row-style-textContainer mt-4 mb-4">
              <Col
                xs={12}
                className="bottom-menu-item"
                onClick={this.onClickItem}
              >
                <a
                  href="https://promotionwingman.com/resources/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Resources
                </a>
              </Col>
              <Col
                xs={12}
                className="bottom-menu-item"
                onClick={this.onClickItem}
              >
                <a
                  href="https://kaplan.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </Col>
              <Col
                xs={12}
                className="bottom-menu-item"
                onClick={this.onClickItem}
              >
                <a
                  href="https://promotionwingman.com/terms-of-service/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>
              </Col>
            </Row>
          </Row>
        </div>
      </div>
    );
  }
}

RootNavbarMobile.propTypes = {
  handleTogglerClick: PropTypes.func,
};
